export default __webpack_public_path__ + "static/media/tooth.b0f0f4c1.svg";